/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentProject_ProjectJobAudits.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Project Job Audit API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Thursday, June 27, 2019 - 12:00:28 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      06/27/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Project_ProjectJobAudits = {
    all: (jobid) => requests.get(`/ProjectJobAudits?jobid=${jobid}`),
    get: jobauditid => requests.get(`/ProjectJobAudit/${jobauditid}`),
    delete: jobauditid => requests.del(`/ProjectJobAudit/${jobauditid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentProject_ProjectJobAudits.js